import { WeaTools } from 'ecCom';
export const url = '/api/cube/excelsearch'
export const columns = (params) => {
    return WeaTools.callApi(`${url}/columns`, "get", params);
}
export const datas = (params) => {
    return WeaTools.callApi('/api/ec/dev/table/datas', 'post', params);
}
export const columnWidth = (params) => {
    return WeaTools.callApi(`${url}/columnWidth`, "post", params);
}

export const rowHeight = (params) => {
    return WeaTools.callApi(`${url}/rowHeight`, "post", params);
}

export const getRowHeight=(params)=>{
    return WeaTools.callApi(`${url}/rowHeight`, "get", params);
}

// 获取table 条目数量
export const getTableCounts = params => {
    return WeaTools.callApi('/api/ec/dev/table/counts', 'POST', params);
  };

  // 存储新的分页大小
export const setTablePageSize = params => {
    return WeaTools.callApi('/api/ec/dev/table/pageSize', 'POST', params);
  };
 //获取数据和时间 
export const getDataAndTime = (params) => {
    return WeaTools.callApi(`${url}/getDataAndTime`, "post", params);
}

 //保存颜色
 export const cellColor = (params) => {
    return WeaTools.callApi(`${url}/cellColor`, "post", params);
}

 //获取颜色数据
 export const getCellColor = (params) => {
    return WeaTools.callApi(`${url}/getCellColor`, "get", params);
}

 //校验颜色是否过期
 export const checkColorIsChange = (params) => {
    return WeaTools.callApi(`${url}/checkColorIsChange`, "post", params);
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/apis/excelsearch.ts